<template>
  <div>
    <a-modal 
      id="invoices-payment-modal"
      title="Pago de facturas" 
      centered
      v-model:visible="modalProps.visibility"
      @cancel="handleCloseModal"
    >

      <a-row class="mb-4">
        <a-col :span="3">
          <exclamation-circle-outlined :style="{ fontSize: '35px', color: '#FFBF01' }" />
        </a-col>
        <a-col :span="20">
          <a-typography-text class="text-gray-8 fw-regular mb-4" :level="5">
            ¿Estás seguro que deseas marcar como pagadas con la misma fecha de pago todas las facturas asociadas a este formulario de
            cobranza?.
          </a-typography-text>
        </a-col>
      </a-row>

      <a-row>
        <a-col>
          <a-form name="form" layout="vertical" ref="formRef" :model="paymentFormState" :rules="rules">
          <a-form-item required name="invoicePaymentDate" label="Seleccione fecha de pago para todas las facturas:">
            <a-date-picker placeholder="DD-MM-AAAA" v-model:value="paymentFormState.invoicePaymentDate"
            :style="{ width: '100%' }" :format="dateFormat" />
          </a-form-item>
          </a-form>
        </a-col>
      </a-row>
      
      <template #footer>
        <a-button key="back" @click="handleCloseModal" :disabled="loadingModalCancel">Volver atrás</a-button>
        <a-button key="submit" :loading="loadingModal" :disabled="paymentFormState.invoicePaymentDate == null" type="primary"
        @click="handleSendPayment">Sí, confirmar</a-button>
      </template>

    </a-modal>
  </div>
</template>

<script>
import {
  PATCH_MARK_INVOICES_PAID,
  FETCH_COLLECTION_GROUP_COLLECTIONS
} from '@/store/types';
import { ref, reactive, onMounted, onBeforeUnmount, watch } from 'vue';
import { useStore } from 'vuex';
import notification from '@/utils/notifications';
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';

export default {
  name: 'CollectionGroupPaymentModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    idModal: {
      type: Number,
      default: 1
    },
    dataInfo: {
      type: Object,
      default: () => ({})
    },
    collectionFormId: {
      type: [String, Number],
      default: 0
    }
  },
  components: {
    'exclamation-circle-outlined': ExclamationCircleOutlined,
  },
  setup(props, { emit }) {

    const store = useStore();
    const dataPaid = ref();
    const loadingData = ref(false);

    const paymentFormState = reactive({
      invoicePaymentDate: null
    });

    const formRef = ref();
    const rules = {
      invoicePaymentDate: [
        {
          required: true,
          type: 'object',
          trigger: 'change',
          message: 'Seleccione una fecha'
        }
      ]
    };
    const dateFormat = 'DD-MM-YYYY';
    const loadingModal = ref(false);
    const loadingModalCancel = ref(false);
    const interval = ref(0);

    const modalProps = reactive({
      visibility: false,
      title: 'Pago de facturas de múltiples cobranzas',
      loading: false,
    });

    const handleCloseModal = () => {
      loadingModalCancel.value = false;
      modalProps.visibility = false;
      emitResponse();
    };

    const emitResponse = () => {
      emit('update:modelValue', false);
    };

    const getCollectionGroupCollections = async () => {
      loadingData.value = true;
      try {
        await store.dispatch(
          FETCH_COLLECTION_GROUP_COLLECTIONS,
          props.collectionFormId
        );
      } catch (error) {
        loadingData.value = false;
        console.log('error', error);
      } finally {
        loadingData.value = false;
      }
    };
    
    const handleSendPayment = async () => {
      loadingModalCancel.value = true;
      loadingModal.value = true;
      const collectionGroupId = props.collectionFormId;
      const date = { paidAt: paymentFormState.invoicePaymentDate };
      try {
        await store.dispatch(PATCH_MARK_INVOICES_PAID, {
          collectionGroupId,
          date
        });
        emit('paymentCompleted');
        getCollectionGroupCollections();
        loadingModal.value = false;
        notification(
          'success',
          'Correcto',
          'Las fechas de pago de todas las facturas han sido editadas con éxito'
        );
      } catch (error) {
        loadingModal.value = false;
        console.log('error', error);
        notification(
          'error',
          'Error',
          'Ha surgido un problema con el pago de las facturas'
        );
      }
      handleCloseModal();
    };

    watch(
      () => props.modelValue,
      (newVal) => {
        modalProps.visibility = newVal;
      }
    );

    watch(paymentFormState, (val) => {
      if (val.invoicePaymentDate == null) {
        loadingModal.value = true;
      } else {
        loadingModal.value = false;
      }
    });

    onBeforeUnmount(() => {
      clearInterval(interval.value);
    });
    onMounted(async () => {
      await getCollectionGroupCollections();
    });


    return {
      paymentFormState,
      rules,
      loadingModal,
      loadingModalCancel,
      modalProps,
      handleSendPayment,
      handleCloseModal,
      formRef,
      dateFormat,
      dataPaid
    };
  }
};

</script>